export const GET_VACANCIES = 'GET_VACANCIES';
export const GET_VACANCY = 'GET_VACANCY';
export const GET_FACETS = 'GET_FACETS';
